
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/Interaction/ScrollReveal.html",
      function () {
        return require("private-next-pages/Interaction/ScrollReveal.html.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/Interaction/ScrollReveal.html"])
      });
    }
  